import { useContext, useEffect, useRef, useState } from "react";
import { MdOutlinePersonAdd } from "react-icons/md";
import { api, themeColor } from "../../..";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ShowSaveCancelPopUp } from '../../../Components/Popup/Popup';
import AddAgent from "./AddAgent/AddAgent";
import Agent from "./Agent/Agent";
import { useTranslation } from 'react-i18next';
import Spinner from "../../../Components/Spinner/Spinner";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { PusherContext } from "../../../PusherContextProvider";

let addedPusher = false

const Agents = () => {
	const [members, setMembers] = useState<Array<any> | null>(null);
	const [users, setUsers] = useState<Array<any>>([]);
	const [loading, setLoading] = useState(true);
	const [sortOrder, setSortOrder] = useState('DSC');
	const [hideName, setHideName] = useState(false);
	const [hideActive, setHideActive] = useState(false);
	const { id } = useParams();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const membersLength = useRef<number>();
	const pusher = useContext(PusherContext)

	membersLength.current = members?.length ?? 0

	useEffect(() => {
		if(api.accessToken) {
			if(id) {
				addedPusher = false
				api.calls.queue.members.browse(id)
				.then((r: any) => {
					setLoading(false);
					redoMembers(r.data)
				} )

				getUsers();
			} else {
				toast.error(t('unable_to_get_queue_members'))
			}
		} else {
			navigate("/login");
		}
		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		if(!addedPusher && members && api.accessToken && pusher) {
			addedPusher = true

			pusher.pushOnMessageListener('Queue', (q: any) => {
				if(q.queue.id === id && membersLength.current !== q.members.length) {
					membersLength.current = q.members.length
					redoMembers(q.members)
				}
			})
		}

		// eslint-disable-next-line
	}, [members, id])

	// Get users
	const getUsers = () => {
		const user = api.getUser();

		if(user) {
			api.calls.company.user.browse(user.pbx_company_id, true)
			.then((r: any) => {
				setUsers(r.data);
			} );
		}
	}

	const redoMembers = (newMembers: Array<any>) => {
		setMembers(
			newMembers.map((member:any) => (
				<Agent
					key={member.id}
					member={member}
				/>
			))
		)
	}

	const addAgent = () => {
		let checked: any;

		ShowSaveCancelPopUp(t('add_agent'),
			<AddAgent
				users={users}
				members={members}
				onCheckedChanged={(c: any) => checked = c}
			/>,
			(r:any) => {
				if(r) {
					if(checked.length !== 0) {
						for(const c in checked) {
							if(checked[c] === true) {
								try {
									if (id) {
										api.calls.queue.members.create(id, {
											pbx_user_id: c,
											paused: '0',
											penalty: '0',
											wrapuptime: '0',

										})
										.then((r:any) => {
											if(r.status === 200) {
												toast.success(t('agent_successfully_added'));
											}
										})
										.catch(() => {
											toast.warning(t('agents_already_added'));
										})
									}
								} catch (error) {
									toast.error(t('unable_to_add_agents'));
								}
							}
						}
					}
				}
		},themeColor);
	}

	// Sorting
	const sorting = (col:any) => {
		if(col && members) {
			const isAscending = sortOrder === 'ASC';

			const sorted = [...members].sort((a, b) =>
				(a.props.member[col].toLowerCase() > b.props.member[col].toLowerCase() ? 1 : -1) * (isAscending ? 1 : -1)
			);

			setMembers(sorted);
			setSortOrder(isAscending ? 'DSC' : 'ASC');
		}
	}

	if(loading) {
		return <div className="callout">
			<div className="agents">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

	return <div className="callout">
		<div className="agents">
			<div className="small-6 medium-6 large-6 columns">
				<b>{t('agents')}</b>
			</div>
			<div  className={"small-6 medium-6 large-6 columns" + (users.length === 0 ? ' hide' : '')}>
				<MdOutlinePersonAdd
					className="add-agent"
					title={t('add_agent')}
					onClick={() => addAgent()}
				/>
			</div>
			<div className="row agents-data">
				<div className="small-12 medium-12 large-12 columns">
					<table className="unstriped">
						<thead>
							<tr>
								<th className="sort"
									onClick={() => {
										sorting('paused');
										setHideName(true);
										setHideActive(false);
									}}
								>
									<b>{t('name')}</b>
									{hideName === true ? sortOrder === 'DSC' ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp/> : ''}
								</th>
								<th>
									<b>{t('answered')}</b>
								</th>
								<th>
									<b>{t('on_call')}</b>
								</th>
								<th>
									<b>{t('idle')}</b>
								</th>
								<th className="sort"
									onClick={() => {
										sorting('paused');
										setHideActive(true);
										setHideName(false);
									}}
								>
									<b>{t('active')}</b>
									{hideActive === true ? sortOrder === 'DSC' ? <MdKeyboardArrowDown/> : <MdKeyboardArrowUp/> : ''}
								</th>
								<th>
									<b>{t('delete')}</b>
								</th>
							</tr>
						</thead>
						<tbody>
							{
								members?.length
								?
									members
								:
									<tr>
										<td className="center-text" colSpan={5}>{t('no_data_found')}</td>
									</tr>
							}
						</tbody>
					</table>
				</div>
			</div>

		</div>
	</div>
}

export default Agents;
